export const COOKIE_LOCALE = 'crypto.locale';
export const COOKIE_ON_LOGIN = 'onLogin';
export const COOKIE_GUIDE_TIPS = 'oex-margin-slider-tip';
export const COOKIE_LOGOUT_PATH = 'crypto.logoutPath';
export const COOKIE_AFFILIATE_TNC = 'crypto.affiliate.tnc';
export const COOKIE_AFFILIATE_CAN_TNC = 'crypto.affiliate.can.tnc';
export const COOKIE_TOP_BANNER = 'crypto.topbanner';
export const COOKIE_TOKEN = 'token';
export const COOKIE_BROKER_ONBOARDING = 'crypto.brokerProgramOnboarding';
// Broker Programme
export const COOKIE_BROKER_TNC = 'crypto.broker.tnc';
export const COOKIE_DISCLAIMER = 'crypto.disclaimer';
export const COOKIE_TRAVEL_RULE = 'crypto.travel.rule.read';
export const COOKIE_STAKING_RESTAKING = 'crypto.staking.restaking';
export const COOKIE_STAKING_POL = 'crypto.staking.pol';
export const COOKIE_STAKING_CDCSOL = 'crypto.staking.cdcsol';
